import React from 'react';

import {
    useCurationConfigValue,
    useSetCurationConfigState
} from '../../../hooks/widgetConfiguration.js';

import RIQButton from '../../../components/RIQButton.jsx';


export default function AdvancedSearchButton() {
    const searchTerms = useCurationConfigValue('searchTerms');
    const setShowAdvancedSearchEditor = useSetCurationConfigState('showAdvancedSearchEditor');
    const setSelectedSource = useSetCurationConfigState('selectedSource');
    const language = useCurationConfigValue('language');
    const setSelectedLanguage = useSetCurationConfigState('selectedLanguage');
    const companyId = useCurationConfigValue('companyId');

    function showEditor() {
        setSelectedLanguage(language);
        setSelectedSource(null);
        setShowAdvancedSearchEditor(true);

        const queryType = companyId ? 'company-query' : 'keyword';
        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ListeningClickedEdit, {
            source: `toolbar-edit-${queryType}`
        });
    }

    let searchTerm = _.head(searchTerms);
    const searchTermCount = _.size(searchTerms);
    if (searchTermCount > 1) {
        searchTerm += '…';
    }

    return (
        <div className='tlw-flex tlw-w-full tlw-flex-row sm_tlw-w-auto'>
            <div className='tlw-h-17 tlw-min-w-72 tlw-flex-grow tlw-rounded-sm tlw-rounded-r-none tlw-border tlw-border-r-0 tlw-border-solid tlw-border-gray-600 tlw-bg-white tlw-px-6 tlw-py-1.5 tlw-text-left tlw-text-gray-800 tlw-shadow-sm'>
                <div className='tlw-text-10 tlw-leading-12 tlw-text-gray-500' >Search Terms</div>
                <div className='tlw-max-w-80 tlw-truncate tlw-text-sm tlw-leading-14'>{searchTerm}</div>
            </div>
            <RIQButton
                id='edit-search-button'
                className='tlw-inline-flex tlw-h-17 tlw-w-[70px] tlw-items-center tlw-rounded-sm tlw-rounded-l-none tlw-bg-white tlw-px-6 tlw-py-1.5 tlw-text-gray-800 tlw-shadow-sm'
                onClick={showEditor}
            >
                <span className='fa fa-wrench tlw-mr-2'/>
                Edit
            </RIQButton>
        </div>
    );
}
